export enum AccessPermission {
  UNDEFINED,
  SUPERADMIN,
  GROUPADMIN,
  SUBGROUPADMIN,
}

export default AccessPermission;
